import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitotrimbkeshwarcab() {



    const cardData = {





keyword: "Mumbai to Trimbakeshwar Cab",

headingDescription: "Shreesha Tours & Travels offers reliable and comfortable Mumbai to Trimbakeshwar Cab Service for devotees, families, and travelers planning a spiritual journey to one of Maharashtra's most important pilgrimage destinations. We provide chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, and premium cab options for a safe and convenient travel experience. With experienced drivers, well-maintained vehicles, transparent pricing, doorstep pickup from Mumbai, flexible booking options, and 24/7 customer support, we ensure a smooth and peaceful pilgrimage trip. Whether you need a one-way taxi, round trip cab, family temple tour, or customized Nashik pilgrimage package, Shreesha Tours & Travels delivers dependable transportation with complete comfort and convenience.",

topPlaces: [
  {
    title: "Trimbakeshwar Jyotirlinga Temple",
    description: "Trimbakeshwar Temple is one of the twelve Jyotirlingas of Lord Shiva and a major pilgrimage destination in Maharashtra. Devotees visit this sacred temple for spiritual rituals and darshan throughout the year."
  },
  {
    title: "Nashik Panchavati",
    description: "Panchavati is a famous religious area in Nashik associated with Lord Ram's exile period. It features important attractions like temples, ghats, and spiritual landmarks."
  },
  {
    title: "Sula Vineyards Nashik",
    description: "Sula Vineyards is one of Nashik's most popular attractions, offering vineyard tours, wine tasting experiences, beautiful views, and relaxing surroundings for visitors."
  },
  {
    title: "Anjaneri Hills Nashik",
    description: "Anjaneri Hills is a scenic trekking destination near Trimbakeshwar, known for beautiful landscapes, waterfalls, greenery, and its connection with Lord Hanuman's birthplace."
  },
  {
    title: "Dudhsagar Falls Nashik",
    description: "Dudhsagar Falls is a beautiful seasonal waterfall located near Nashik, surrounded by nature and greenery. It is a popular spot during the monsoon season."
  },
  {
    title: "Muktidham Nashik",
    description: "Muktidham is a famous marble temple complex in Nashik featuring replicas of important Hindu temples and sacred sites. It attracts pilgrims and tourists throughout the year."
  },
  {
    title: "Kalaram Temple Nashik",
    description: "Kalaram Temple is an ancient and historic temple dedicated to Lord Ram, known for its beautiful architecture and religious significance in Nashik."
  },
  {
    title: "Pandavleni Caves Nashik",
    description: "Pandavleni Caves are ancient Buddhist rock-cut caves located near Nashik, famous for historic sculptures, inscriptions, and panoramic city views."
  },
  {
    title: "Saptashrungi Devi Temple",
    description: "Saptashrungi Temple is a famous hilltop pilgrimage destination near Nashik dedicated to Goddess Saptashrungi. It is one of Maharashtra's important Shakti Peetha sites."
  },
  {
    title: "Bhandardara",
    description: "Bhandardara is a peaceful hill destination near Nashik known for Arthur Lake, waterfalls, mountains, and natural beauty. It is a popular getaway for families and nature lovers."
  }
],




"services": [
  {
    "name": "Mumbai to Trimbakeshwar Cab",
    "description": "Book Mumbai to Trimbakeshwar Cab for a comfortable and reliable pilgrimage journey with professional chauffeurs and well-maintained AC vehicles. Enjoy a peaceful temple visit with Sedan, Ertiga, Innova, Innova Crysta, SUV, and premium cab options suitable for family darshan, religious tours, and spiritual travel."
  },
  {
    "name": "Mumbai to Trimbakeshwar Taxi",
    "description": "Choose Mumbai to Trimbakeshwar Taxi for safe and convenient travel to the famous Trimbakeshwar Jyotirlinga Temple. Get experienced drivers, clean AC cars, doorstep pickup, affordable fares, and reliable taxi service for devotees and families."
  },
  {
    "name": "Mumbai to Trimbakeshwar Cab Service",
    "description": "Book Mumbai to Trimbakeshwar Cab Service for hassle-free religious transportation with trained chauffeurs and comfortable vehicles. Our cab services are ideal for temple visits, family trips, weekend pilgrimages, and spiritual journeys with flexible travel options."
  },
  {
    "name": "Mumbai to Trimbakeshwar Taxi Service",
    "description": "Hire Mumbai to Trimbakeshwar Taxi Service for a smooth and relaxing journey with professional drivers and premium vehicles. Enjoy convenient transportation, comfortable seating, and reliable cab facilities for Trimbakeshwar Darshan."
  },
  {
    "name": "Mumbai to Trimbakeshwar Cab Booking",
    "description": "Complete Mumbai to Trimbakeshwar Cab Booking with easy reservations and multiple vehicle options. Select Sedan, SUV, Ertiga, Innova, or premium cars according to your group size and enjoy a comfortable pilgrimage journey."
  },
  {
    "name": "Mumbai to Trimbakeshwar Temple Taxi",
    "description": "Book Mumbai to Trimbakeshwar Temple Taxi for safe and comfortable transportation to one of Maharashtra's famous Jyotirlinga temples. Enjoy reliable service, experienced chauffeurs, and convenient pickup facilities for devotees."
  },
  {
    "name": "Mumbai to Trimbakeshwar Darshan Cab",
    "description": "Choose Mumbai to Trimbakeshwar Darshan Cab for a peaceful temple visit with dedicated vehicles and professional drivers. Perfect for family darshan, religious groups, and spiritual travelers looking for comfortable travel."
  },
  {
    "name": "Mumbai to Trimbakeshwar Tour Package",
    "description": "Reserve Mumbai to Trimbakeshwar Tour Package by cab for a complete religious travel experience. Enjoy flexible schedules, comfortable vehicles, and customized cab packages for temple visits and sightseeing around Nashik."
  },
  {
    "name": "Mumbai to Trimbakeshwar Car Rental",
    "description": "Select Mumbai to Trimbakeshwar Car Rental for chauffeur-driven vehicles designed for pilgrimage and family travel. Get spacious cars, professional drivers, and flexible rental plans for a smooth journey."
  },
  {
    "name": "Mumbai to Trimbakeshwar One Way Cab",
    "description": "Book Mumbai to Trimbakeshwar One Way Cab for affordable drop taxi service without return fare charges. Travel comfortably with experienced chauffeurs, clean vehicles, and flexible pickup options from Mumbai."
  },
  {
    "name": "Mumbai to Trimbakeshwar Round Trip Taxi",
    "description": "Reserve Mumbai to Trimbakeshwar Round Trip Taxi for convenient return travel with flexible timings and comfortable vehicles. Ideal for same-day darshan, family pilgrimages, and spiritual tours."
  },
  {
    "name": "Mumbai to Trimbakeshwar Innova Cab",
    "description": "Choose Mumbai to Trimbakeshwar Innova Cab for spacious and comfortable travel with premium seating and extra luggage space. Perfect for families and groups planning a temple darshan trip."
  },
  {
    "name": "Mumbai to Trimbakeshwar Ertiga Cab",
    "description": "Book Mumbai to Trimbakeshwar Ertiga Cab for affordable group transportation with comfortable interiors and reliable performance. Suitable for families and small groups visiting Trimbakeshwar Temple."
  },
  {
    "name": "Mumbai to Trimbakeshwar Religious Tour Cab",
    "description": "Choose Mumbai to Trimbakeshwar Religious Tour Cab for safe and convenient spiritual travel. Enjoy professional chauffeurs and comfortable vehicles for Jyotirlinga Darshan, temple tours, and religious journeys."
  },
  {
    "name": "Best Mumbai Trimbakeshwar Cab Service",
    "description": "Select the Best Mumbai Trimbakeshwar Cab Service for safe, comfortable, and reliable pilgrimage travel. Enjoy premium vehicles, trained chauffeurs, flexible booking options, and affordable cab packages for Trimbakeshwar Darshan with family and devotees."
  }
],
"tableData": [
  ["Mumbai to Trimbakeshwar Cab", "Mumbai to Trimbakeshwar Taxi"],
  ["Mumbai to Trimbakeshwar Cab Service", "Mumbai to Trimbakeshwar Taxi Service"],
  ["Mumbai to Trimbakeshwar Cab Booking", "Mumbai to Trimbakeshwar Temple Taxi"],
  ["Mumbai to Trimbakeshwar Darshan Cab", "Mumbai to Trimbakeshwar Tour Package"],
  ["Mumbai to Trimbakeshwar Car Rental", "Mumbai to Trimbakeshwar One Way Cab"],
  ["Mumbai to Trimbakeshwar Round Trip Taxi", "Mumbai to Trimbakeshwar Innova Cab"],
  ["Mumbai to Trimbakeshwar Ertiga Cab", "Mumbai to Trimbakeshwar Religious Tour Cab"],
  ["Best Mumbai Trimbakeshwar Cab Service", ""]
],




whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Trimbakeshwar Cab Service",
    WhyChoosedescription: "Shreesha Travels provides reliable Mumbai to Trimbakeshwar cab services for devotees, families, and travellers visiting the famous Jyotirlinga temple. Enjoy a peaceful spiritual journey with comfortable cars, professional chauffeurs, and flexible travel options."
  },
  {
    WhyChooseheading: "Hassle-Free Pilgrimage Travel from Mumbai",
    WhyChoosedescription: "Plan your religious trip from Mumbai to Trimbakeshwar with convenient cab booking. Our services are suitable for temple visits, family tours, senior citizens, and customized Nashik pilgrimage routes."
  },
  {
    WhyChooseheading: "Comfortable Vehicles for Every Group Size",
    WhyChoosedescription: "Choose from Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and other vehicles according to your passenger count and travel requirements."
  },
  {
    WhyChooseheading: "Perfect for Jyotirlinga & Religious Tours",
    WhyChoosedescription: "Our Mumbai to Trimbakeshwar taxi service is ideal for devotees planning temple visits, Jyotirlinga darshan, family pilgrimages, and spiritual tours covering nearby Nashik attractions."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Cab Options",
    WhyChoosedescription: "Book a one-way cab for direct travel to Trimbakeshwar or select a round-trip package with flexible return timing, waiting options, and customized sightseeing plans."
  },
  {
    WhyChooseheading: "Experienced Drivers on Maharashtra Routes",
    WhyChoosedescription: "Our professional drivers have excellent knowledge of Mumbai-Nashik routes and pilgrimage destinations, ensuring safe travel, timely service, and a comfortable journey."
  },
  {
    WhyChooseheading: "Well-Maintained Cars for Peaceful Journeys",
    WhyChoosedescription: "Every vehicle is regularly serviced, cleaned, air-conditioned, and inspected before departure to provide a smooth and relaxing travel experience for passengers."
  },
  {
    WhyChooseheading: "Book Mumbai to Trimbakeshwar Cab with Shreesha Travels",
    WhyChoosedescription: "Get reliable cab assistance, transparent pricing, comfortable vehicles, and professional chauffeur services for your Mumbai to Trimbakeshwar pilgrimage journey."
  }
]

};

const faqData = [
  {
    question: "Can I book a Mumbai to Trimbakeshwar cab for temple darshan?",
    answer: "Yes, we provide comfortable cab services from Mumbai to Trimbakeshwar for devotees, families, and spiritual journeys."
  },
  {
    question: "Is Mumbai to Trimbakeshwar one-way cab service available?",
    answer: "Yes, one-way taxi bookings are available for travellers who require direct transportation from Mumbai to Trimbakeshwar."
  },
  {
    question: "Which cars are available for Mumbai to Trimbakeshwar travel?",
    answer: "We offer Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, and Tempo Travellers."
  },
  {
    question: "Can I combine Trimbakeshwar with Nashik sightseeing?",
    answer: "Yes, customized packages can include Nashik sightseeing places, nearby temples, and other destinations according to your itinerary."
  },
  {
    question: "Is this cab service comfortable for senior citizens?",
    answer: "Yes, our spacious vehicles and experienced drivers make the journey convenient and comfortable for senior citizens."
  },
  {
    question: "Do you provide round-trip Mumbai to Trimbakeshwar taxi booking?",
    answer: "Yes, round-trip cab services are available with flexible return schedules and waiting options."
  },
  {
    question: "Can I book a cab from Mumbai Airport to Trimbakeshwar?",
    answer: "Yes, airport pickup and direct cab services can be arranged according to your travel requirements."
  },
  {
    question: "How is the Mumbai to Trimbakeshwar cab fare calculated?",
    answer: "The fare depends on vehicle category, travel distance, trip duration, waiting time, and selected package."
  },
  {
    question: "Are same-day return trips available from Mumbai?",
    answer: "Yes, same-day return cab options can be arranged based on your temple visit schedule and travel convenience."
  },
  {
    question: "How can I book Mumbai to Trimbakeshwar Cab with Shreesha Travels?",
    answer: "Share your travel date, pickup location, passenger details, preferred vehicle, and trip requirements to receive a customized quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Patil",
    feedback: "The Mumbai to Trimbakeshwar journey was very comfortable. The driver was experienced, the car was clean, and the complete pilgrimage trip was arranged smoothly.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Joshi",
    feedback: "Our family temple visit became stress-free with Shreesha Travels. The comfortable vehicle and professional service made the journey memorable.",
    rating: 5
  }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Trimbakeshwar Cab",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-trimbakeshwar-cab.webp",
  "description":
    "Book Mumbai to Trimbakeshwar Cab with Shreesha Tours & Travels for comfortable and reliable pilgrimage taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for temple visits, Jyotirlinga darshan, family trips, religious tours, and outstation journeys from Mumbai to Trimbakeshwar with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-trimbakeshwar-cab"
  }
};



    return (
        <div>

<Helmet>
  <title>Mumbai to Trimbakeshwar Cab | Jyotirlinga Tour Taxi | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Trimbakeshwar Cab with Shreesha Travels for safe and comfortable pilgrimage taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for Trimbakeshwar temple visits, Jyotirlinga darshan, family trips, and religious tours with 24x7 booking."
  />

  <meta
    name="keywords"
    content="Mumbai to Trimbakeshwar Cab, Mumbai to Trimbakeshwar Taxi, Mumbai to Trimbakeshwar Cab Service, Mumbai to Trimbakeshwar Taxi Service, Mumbai to Trimbakeshwar Cab Booking, Mumbai to Trimbakeshwar Car Rental, Mumbai to Trimbakeshwar One Way Cab, Mumbai to Trimbakeshwar Round Trip Taxi, Mumbai Trimbakeshwar Tour Package, Mumbai Jyotirlinga Cab Service, Trimbakeshwar Temple Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/69.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitotrimbkeshwarcab;